<template>
  <div class="recharge-modal">
    <el-dialog
      :visible="dialogDisplay"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="closeModal"
      :width="'620px'">
      <template #title>
        <div class="dialog-title-box">
          <span>{{$t('message.wallet.rechargeForAccount')}}</span>
          <rhcn-button
            class="icon-button dialog-close-icon"
            size="small"
            @click="dialogDisplay = false"
          ><i class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <div v-loading="dataLoading" class="recharge-content-box">
        <div class="recharge-content">
          <p class="recharge-content-title">{{$t('message.wallet.rechargeBankInfo')}}</p>
          <el-descriptions class="recharge-content-descriptions" :column="2" :colon="false" :direction="'vertical'">
            <el-descriptions-item v-for="(item, index) in detailList" :key="index">
              <template slot="label">
                <span>{{ item.isInternationalization ? $t(item.label) : item.label }}<i class="iconfont icon-copy margin-left-10" @click="handleCopy(item.value)"></i></span>
              </template>
              <div>{{item.value}}</div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="recharge-bottom-tips">
          <p>{{$t('message.wallet.rechargeTips1')}}</p>
          <p v-if="selectCurrency === 'USD'">{{$t('message.wallet.rechargeTips2')}}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RhcnButton from '@/components/form/button.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { getVaAccountInfoByCurrency } from '@/views/collection/api/va.js';

export default {
  name: 'RechargeModal',
  components: {
    RhcnButton,
  },
  props: {
    balances: {
      type: Array,
      default: () => ([]),
    },
    refcurrency: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogDisplay: false,
      currencyList: [],
      selectCurrency: 'USD',
      detailList: [],
      dataLoading: false,
    };
  },
  methods: {
    openModal(currency) {
      console.log('currency', currency);
      this.dialogDisplay = true;
      // this.currencyList = [];
      // for (let i = 0; i < this.balances.length; i++) {
      //   const balance = this.balances[i];
      //   if (['USD', 'GBP', 'EUR'].indexOf(balance.currency) > -1) {
      //     this.currencyList.push({
      //       value: balance.currency,
      //       label: balance.currency,
      //     });
      //   }
      // }
      // this.selectCurrency = currency || 'USD';
      // this.$nextTick(() => {
      //   this.handleCurrencyChange(this.selectCurrency);
      // });

      this.handleCurrencyChange(currency);
    },
    closeModal() {
      this.dialogDisplay = false;
    },
    async handleCopy(data) {
      await this.$copyText(data);
      ShowSuccessMessage(this.$t('message.common.copySuccess'));
    },
    async handleCurrencyChange(value) {
      console.log('this.refcurrency', this.refcurrency);
      this.dataLoading = true;
      try {
        this.detailList = [];
        const res = await getVaAccountInfoByCurrency({
          currency: value,
        });
        this.detailList = res.infoList;
        console.log('this.detailList', this.detailList);
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
  },
};
</script>

<style lang="scss" scope>
@import '@/styles/variables.scss';
.recharge-modal {
  .el-dialog__body {
    display: flex;
    justify-content: center;
    padding: 0 30px;
    padding-top: 20px;
  }

  .recharge-content-box {
    width: 100%;

    .select-currency-title {
      font-weight: 400;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
    }

    .recharge-currency-select {
      width: 120px;

      .el-input__inner {
        font-weight: bold;
        color: $color-text-primary;
        background-color: white;
      }

      .el-icon-arrow-up {
        color: $color-text-primary;
      }
    }

    .recharge-content {
      background: $color-default;
      border-radius: 2px;
      padding: 15px 10px;

      .recharge-content-title {
        font-weight: bold;
        font-size: 14px;
        color: $color-text-primary;
        line-height: 20px;
      }

      .recharge-content-descriptions {
        margin-top: 15px;
        .el-descriptions__body {
          background-color: transparent;

          .el-descriptions-item__label  {
            font-weight: 400;
            font-size: 14px;
            color: $color-text-primary;
            line-height: 20px;

            .icon-copy {
              color: $color-success;
              font-size: 12px;
              cursor: pointer;
            }
          }

          .el-descriptions-item__content {
            color: $color-text-primary;
            word-break: break-all;
            font-weight: 800;
            line-height: 28px;
            font-size: 14px;
            font-family: Avenir-Heavy, Avenir;
            margin-right: 20px;
          }
        }
      }
    }

    .recharge-bottom-tips {
      font-weight: 400;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 24px;
    }
  }

  .el-dialog__header{
    height: 64px;
    padding: 0;
    padding-left: 30px;
    padding-right: 20px;
    border-bottom: 1px solid rgba(0,32,63,0.08);
    font-size: 20px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 36px;
  }

  .dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .dialog-close-icon {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }

      .el-icon-close {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
